module.exports = __webpack_public_path__ + "static/img/IPimg5.0c11443b.png";